module.exports = __webpack_public_path__ + "img/7af8013.png";